namespace RioERP.Masters {
    export interface PendingOrderJobSettingsForm {
        NopUrl: Serenity.StringEditor;
        RunJob: Serenity.BooleanEditor;
    }

    export class PendingOrderJobSettingsForm extends Serenity.PrefixedContext {
        static formKey = 'Masters.PendingOrderJobSettings';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!PendingOrderJobSettingsForm.init)  {
                PendingOrderJobSettingsForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;
                var w1 = s.BooleanEditor;

                Q.initFormType(PendingOrderJobSettingsForm, [
                    'NopUrl', w0,
                    'RunJob', w1
                ]);
            }
        }
    }
}
